import { render, staticRenderFns } from "./Center-Educenter.vue?vue&type=template&id=2645baaa"
import script from "./Center-Educenter.vue?vue&type=script&lang=js"
export * from "./Center-Educenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports